import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import New from '../../templates/New';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
export class NewView extends Component {

	render () {
		const {
			buttonLabel,
			content,
			heading,
			href,
			subheading,
		} = this.props.content.landingPage.new;
		return (
			<New
				{...{
					buttonLabel,
					content,
					heading,
					href,
					subheading,
				}}
			/>
		);
	}

}

export default withLanguageContext(NewView);



// WEBPACK FOOTER //
// ./src/components/views/NewView/NewView.js